import React, { ReactNode } from 'react';
import styles from './assets/screen.module.scss';
import classNames from 'classnames';
import OrderExpiredReportsGrid from './components/OrderExpiredReportsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IOrderExpiredReport } from 'src/types/orderExpiredReport';
import user from '../../../../../services/user-auth';
import UserRole from '../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IOrderExpiredReport>;
    students: SelectObject[];
    districts: SelectObject[];
    vendors: SelectObject[];
    serviceTypes: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getStudents: (params: QueryParams) => void;
    getDistricts: (params: QueryParams) => void;
    getVendors: (params: QueryParams) => void;
    getServiceTypes: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class OrderExpiredReportList extends React.Component<Props> {
    componentDidMount() {
        this.props.getServiceTypes({
            page: 1,
        });
        this.props.getStudents({
            page: 1,
        });
    }
    public render(): ReactNode {
        const { data, getData, students, districts, vendors, getDataCsv, serviceTypes } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(styles.pageHeading, 'pageHeading')}>
                    <h2 className={classNames(styles.headingTitle, 'pageHeadingTitle')}>
                        Expiring Orders {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                <div className={classNames(styles.list)}>
                    <OrderExpiredReportsGrid
                        students={students}
                        districts={districts}
                        getDataCsv={getDataCsv}
                        vendors={vendors}
                        data={data}
                        getData={getData}
                        serviceTypes={serviceTypes}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default OrderExpiredReportList;
